export const SURVEY_COMMON_TYPE = 'common';
export const SURVEY_TEMPLATE_TYPE = 'template';
export const SURVEY_NEXTIVAONE_OPTIMIZED_TYPE = 'connect_survey';
export const SURVEY_TEMPLATE_NEXTIVAONE_OPTIMIZED_TYPE = 'connect_template';
